export const COMPANY_TYPE_PREPAID = 'prepaid'
export const COMPANY_TYPE_POSTPAID = 'postpaid'

export const COMPANY_TYPES = [COMPANY_TYPE_PREPAID, COMPANY_TYPE_POSTPAID]

export default {
    prepaid: COMPANY_TYPE_PREPAID,
    postpaid: COMPANY_TYPE_POSTPAID,
}
